import { useTranslation } from 'react-i18next'

/** Visible before intake and retained after the form becomes a run panel. */
export default function TeamOwnerSummary({ email }: { email: string }) {
  const { t } = useTranslation('pages')
  return <div className="rounded-lg border border-border bg-surface-2 px-3 py-2 text-sm" data-testid="onboarding-team-owner">
    <p className="font-medium text-foreground">{t('adminOnboarding.direct.ownerLabel')}: <span data-testid="onboarding-team-owner-email">{email}</span></p>
    <p className="mt-1 text-xs text-muted-foreground">{t('adminOnboarding.direct.ownerExplanation')}</p>
  </div>
}
